import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

import PortfolioFaultHistogram from './PortfolioFaultHistogram';
import PortfolioFaultChartByCountry from './PortfolioFaultFrequencyChartByCountry';
import PortfolioFaultChartByError from './PortfolioFaultFrequencyChartByError';

import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

const styles = {
  scrollContainer: {
    maxHeight: 'calc(100vh - 200px)', 
    overflowY: 'auto',
    scrollBehavior: 'smooth',
    padding: '1px 0px',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f0f0f0',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#888',
      borderRadius: '4px',
      border: '2px solid #f0f0f0'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
  },
  graphContainerHistogram: {
    margin: '0px 10px 5px 10px',
    marginBottom: '5px',

  },
  graphContainerPieChart: {
    padding: '10px',
  },
  loadingWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    flexDirection: 'column',
  },
  loadingTypography: {
    marginTop: '50px',
  }
};

const PortfolioFaultGraphs = ({
  classes,
  portfolioFaultData,
  portfolioFaultLogData
}) => {
  const [showCharts, setShowCharts] = useState(false);

  useEffect(() => {
    setShowCharts(false); // reset
    const timer = setTimeout(() => {
      setShowCharts(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, [portfolioFaultData, portfolioFaultLogData]);

  return (
    <div className={classes.scrollContainer}>
      {showCharts ? (
        <Grid container spacing={0}>
          <Grid item className={classes.graphContainerHistogram} md={12} sm={12} xs={12}>
            <PortfolioFaultHistogram />
          </Grid>
          <Grid item className={classes.graphContainerPieChart} md={6} sm={6} xs={12}>
            <PortfolioFaultChartByCountry />
          </Grid>
          <Grid item className={classes.graphContainerPieChart} md={6} sm={6} xs={12}>
            <PortfolioFaultChartByError />
          </Grid>
        </Grid>
      ) : (
        <div className={classes.loadingWrapper}>
          <CircularProgress />
          <Typography variant="h6" className={classes.loadingTypography}>Loading...</Typography>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  portfolioFaultData: state.portfolioFaultOverview?.portfolioFaultQueryData?.portfolioFaultData || [],
  portfolioFaultLogData: state.portfolioFaultOverview?.portfolioFaultLogData || []
});

export default connect(mapStateToProps)(withStyles(styles)(PortfolioFaultGraphs));
